import {Avatar, Grid} from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import {useStyles} from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import PropTypes from 'prop-types';

import theme from './theme';

const {
  colors: {background, statusProfilColor},
} = theme;

const ProfilName = ({image, info}) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: {spacing},
  } = useStyles(styles);

  return (
    <div>
      <Grid className={classes.gridContainer} spacing={3}>
        <div>
          <Avatar className={classes.avatar} src={image} />
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: spacing(2),
          })}
        >
          <div className={cx(global.title, classes.name)}>
            {info.name}
            <div
              className={css({
                marginLeft: spacing(1),
              })}
            >
              <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
            </div>
          </div>
          <div className={cx(global.infoText, classes.address)}>
            <RoomIcon className={classes.imgAdress} />
            {info?.address?.cityCode} {info?.address?.city}
          </div>
        </div>
      </Grid>
    </div>
  );
};

const styles = ({spacing}) => ({
  gridContainer: {
    display: 'flex',
    paddingTop: spacing(1),
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  profilStatus: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(5),
  },
  btnVitrine: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
  },
  progressBar: {
    marginTop: spacing(1),
  },
});

ProfilName.propTypes = {
  info: PropTypes.array,
  image: PropTypes.string,
};

export default ProfilName;
